import type {
    AttachmentIconConstantType,
    AttachmentNameParts
} from "./type";
import {
    FileText as FileTextIcon,
    Image as ImageIcon,
    Sheet as SheetIcon,
    Video as VideoIcon,
    Code as CodeIcon,
    type LucideIcon
} from "lucide-react-native";

const ATTACHMENT_ICONS_BY_EXTENSION: Record<string, LucideIcon> = {
    heic: ImageIcon,
    jpeg: ImageIcon,
    webm: VideoIcon,
    webp: ImageIcon,
    xlsx: SheetIcon,
    csv: SheetIcon,
    gif: ImageIcon,
    html: CodeIcon,
    jpg: ImageIcon,
    json: CodeIcon,
    mov: VideoIcon,
    mp4: VideoIcon,
    png: ImageIcon,
    svg: ImageIcon,
    xls: SheetIcon,
    css: CodeIcon,
    tsx: CodeIcon,
    js: CodeIcon,
    ts: CodeIcon,
    py: CodeIcon
};

const ATTACHMENT_EXTENSION_PATTERN = /^\.[A-Za-z0-9]{1,5}$/;

const ATTACHMENT_RTL_PATTERN = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;

export const isAttachmentNameRtl = ({
    title
}: {
    title?: string;
}): boolean => ATTACHMENT_RTL_PATTERN.test(title ?? "");

export const getAttachmentNameParts = ({
    title
}: {
    title?: string;
}): AttachmentNameParts => {
    const name = title ?? "";

    const dotIndex = name.lastIndexOf(".");

    if(dotIndex <= 0 || dotIndex === name.length - 1 || !ATTACHMENT_EXTENSION_PATTERN.test(name.slice(dotIndex))) {
        return {
            extension: "",
            stem: name
        };
    }

    return {
        extension: name.slice(dotIndex),
        stem: name.slice(0, dotIndex)
    };
};

export const getAttachmentIcon = ({
    title,
    icon
}: AttachmentIconConstantType): LucideIcon => {
    if(icon) {
        return icon;
    }

    const {
        extension
    } = getAttachmentNameParts({
        title
    });

    return ATTACHMENT_ICONS_BY_EXTENSION[extension.slice(1).toLowerCase()] ?? FileTextIcon;
};
